// extracted by mini-css-extract-plugin
export default {"burger_ingredients":"burger-ingredients_burger_ingredients__nx47m"};